// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-shadow[data-v-6427fa6d]{text-shadow:-.043em -.043em 0 #fff,0 -.043em 0 #fff,.043em -.043em 0 #fff,.043em 0 0 #fff,.043em .043em 0 #fff,0 .043em 0 #fff,-.043em .043em 0 #fff,-.043em 0 0 #fff;-webkit-text-shadow:-.043em -.043em 0 #fff,0 -.043em 0 #fff,.043em -.043em 0 #fff,.043em 0 0 #fff,.043em .043em 0 #fff,0 .043em 0 #fff,-.043em .043em 0 #fff,-.043em 0 0 #fff}.us-bts-banner[data-v-6427fa6d]{background-color:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
